import { CollectionsManager } from '../../components/collections-manager.js';

/**
 * Collections live here rather than on the collection screens themselves: renaming and
 * deleting are household-wide changes every member sees, and grouping them keeps the
 * browsing screens read-only.
 */
export function CollectionsTab() {
  return (
    <section className="section-group">
      <h2 className="section-title">Collections</h2>
      <CollectionsManager />
    </section>
  );
}
